import { render, staticRenderFns } from "./ModalEditBannerSpace.vue?vue&type=template&id=e5b8ff18&"
import script from "./ModalEditBannerSpace.vue?vue&type=script&lang=js&"
export * from "./ModalEditBannerSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports